import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AuthenticationGuardHoc from 'Hoc/AuthenticationGuardHoc';

import HomeScreen from 'screens/HomeScreen';

import SessionExpiryModal from 'components/SessionExpiryModal/SessionExpiryModal';
import CalculationScreen from 'screens/CalculationsScreen';
import DetailedSchedule from 'screens/DetailedScheduleScreen/index';
import HsRoomPriorities from 'screens/HsRoomPriorities';
import JobPaste from 'screens/JobPaste';
import JobTagScreen from 'screens/JobTagsScreen';
import LoginCallback from 'screens/LoginCallback';
import LoginFailureScreen from 'screens/LoginFailureScreen/loginFailureScreen';
import ReferenceScreen from 'screens/ReferenceScreen';
import ReleasingPriorityList from 'screens/ReleasingPriorityList';
import ScheduleAttainmentScreen from 'screens/ScheduleAttainmentScreen';
import StagingPriorityList from 'screens/StagingPriorityList';
import VisibilityBoardRevamp from 'screens/VisibilityBoardRevamp';
// import VisibilityBoard from 'screens/VisibilityBoard/index';
import PermissionGuardHoc from 'Hoc/PermissionGuardHoc';
import CapacityPlannerScreen from 'screens/CapacityPlanner/CapacityPlannerScreen';
import StandardTimeLegend from 'screens/StandardTimeLegend';
import { checkIfTokenExpired } from 'utils/AuthUtils/tokenUtils';

const AppRoutes = () => {
  const {
    UserStore: { fetchUserDetails, isUserLoggedIn }
  } = useStore();

  useEffect(() => {
    const expiryTimeCheckInterval = setInterval(() => {
      if (isUserLoggedIn() && checkIfTokenExpired()) {
        const sessionExpiryModal = document.getElementById('session-expired-modal');
        if (sessionExpiryModal) {
          sessionExpiryModal.style.display = 'flex';
        }
      }
    }, 1000);

    return () => {
      clearInterval(expiryTimeCheckInterval);
    };
  }, []);

  useEffect(() => {
    if (isUserLoggedIn()) {
      fetchUserDetails();
    }
  }, [isUserLoggedIn]);

  return (
    <>
      <Routes>
        <Route path="" element={<HomeScreen />} />
        <Route path="login-failure" element={<LoginFailureScreen />} />
        <Route path="login/callback" element={<LoginCallback />} />
        <Route element={<AuthenticationGuardHoc />}>
          <Route path="/capacity-planner" element={<CapacityPlannerScreen />} />
          <Route
            path="/reference"
            element={
              <PermissionGuardHoc requiredPermission="ViewReferenceTables">
                <ReferenceScreen />
              </PermissionGuardHoc>
            }
          />
          <Route path="/job-paste" element={<JobPaste />} />

          <Route
            path="/calculations"
            element={
              <PermissionGuardHoc requiredPermission="ProductCalculationsView,CleanCalculationsView,ScheduleCalculationsView">
                <CalculationScreen />
              </PermissionGuardHoc>
            }
          />

          <Route path="/job-tags" element={<JobTagScreen />} />
          <Route path="/visibility-board" element={<VisibilityBoardRevamp />} />
          {/* <Route path="/visibility-board" element={<VisibilityBoard />} /> */}
          <Route path="/detailed-schedule" element={<DetailedSchedule />} />
          <Route path="/staging-priority-list" element={<StagingPriorityList />} />
          <Route path="/releasing-priority-list" element={<ReleasingPriorityList />} />
          <Route path="/schedule-attainment" element={<ScheduleAttainmentScreen />} />
          <Route path="/hs-room-priorities" element={<HsRoomPriorities />} />
          <Route path="/standard-time-legend" element={<StandardTimeLegend />} />
          {/* <Route path="/support-tickets" element={<SupportTicketsScreen />} /> */}
        </Route>
        {/* Catch-all: redirect unknown paths to home/login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <SessionExpiryModal />
    </>
  );
};

export default AppRoutes;
